import { useEffect, useRef } from "react";

export default function useFocusAfterRemove() {
  const pending = useRef(null);

  useEffect(() => {
    if (!pending.current) return;
    const { selector, index, fallbackSelector } = pending.current;
    pending.current = null;
    const remaining = document.querySelectorAll(selector);
    const target = remaining[Math.min(index, remaining.length - 1)] || document.querySelector(fallbackSelector);
    if (target) target.focus();
  });

  return (selector, index, fallbackSelector) => {
    pending.current = { selector, index, fallbackSelector };
  };
}
